import React, { useEffect, useRef, useState } from 'react';
import Icon from '../../../Common/Icon';
import { DropDownList, DropDownWrapper } from './styles';

interface ExportButtonProps {
	onExport: (format: string) => void;
}

const ExportButton = ({ onExport }: ExportButtonProps) => {
	const [dropdownOpen, setDropdownOpen] = useState(false);
	const dropdownRef = useRef<HTMLDivElement>(null); // Create a ref for the dropdown

	const handleButtonClick = () => {
		setDropdownOpen(!dropdownOpen);
	};

	const handleExport = (format: string) => {
		onExport(format);
		// Add your export logic here based on the selected format (CSV, PNG, etc.)
		setDropdownOpen(false);
	};

	// Effect to handle clicks outside the dropdown
	useEffect(() => {
		const handleClickOutside = (event: any) => {
			// Check if the click is outside the dropdown
			if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
				setDropdownOpen(false); // Close the dropdown
			}
		};

		// Bind the event listener
		document.addEventListener('mousedown', handleClickOutside);
		return () => {
			// Cleanup the event listener
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, []);

	return (
		<div ref={dropdownRef}>
			<DropDownWrapper className='pacer61-btn pacer61-purple-btn ms-1' onClick={handleButtonClick}>
				<Icon name={'cloud-arrow-down'} stylePrefix={'fa-regular fa-xl'}></Icon>
			</DropDownWrapper>

			{dropdownOpen && (
				<div className='export-dropdown'>
					<DropDownList>
						<li onClick={() => handleExport('svg')}>Export as SVG</li>
						<li onClick={() => handleExport('png')}>Export as PNG</li>
						<li onClick={() => handleExport('csv')}>Export as CSV</li>
					</DropDownList>
				</div>
			)}
		</div>
	);
};

export default ExportButton;
